/** 默认缩放尺寸 */
export const DEFAULT_SCALE = 2

/** 默认图片格式 */
export const DEFAULT_IMAGE_FORMAT = 'png'
